import { render } from "./ModalConfirmation.vue?vue&type=template&id=dfc9fbbc&scoped=true"
import script from "./ModalConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalConfirmation.vue?vue&type=script&lang=js"

import "./ModalConfirmation.vue?vue&type=style&index=0&id=dfc9fbbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc9fbbc"]])

export default __exports__